import React from 'react';
import { Card, CardContent, styled, Typography } from '@material-ui/core';

import { Config } from '../Configuration';
import ReceiptFooterCard from './ReceiptFooterCard';

export const CardGroup = styled('div')({
  maxHeight: '500px',
  overflowY: 'auto',

  '& .MuiCard-root': {
    '&:not(:last-child)': {
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottom: 'none',
    },
    '&:not(:first-child)': {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
    },
  },
});

interface Props {
  footers: Config['receiptFooters'];
  onEditFooter(id: string): void;
  onDeleteFooter(id: string): void;
}

function ReceiptFooterList({ footers, onEditFooter, onDeleteFooter }: Props) {
  return (
    <div>
      {!footers?.length ? (
        <CardGroup>
          <Card variant="outlined">
            <CardContent>
              <Typography align="center">No footers</Typography>
            </CardContent>
          </Card>
        </CardGroup>
      ) : (
        <CardGroup>
          {footers?.map(footer => (
            <ReceiptFooterCard
              key={footer.id}
              footer={footer}
              onEditFooter={onEditFooter}
              onDeleteFooter={onDeleteFooter}
            />
          ))}
        </CardGroup>
      )}
    </div>
  );
}

export default ReceiptFooterList;
